import React, { useEffect, useState } from "react";
import "./style.scss";
import "../../../style/feature.scss";
import "../../../style/typography.scss";
import "../../../style/block.scss";
import "../../../style/buttons.scss";
import "../../../style/forms.scss";

import { useDispatch, useSelector } from "react-redux";
import { LoginData } from "../../models/LoginData";
import { logInWithPassword } from "../../store/auth/authActions";
import { useNavigate } from "react-router";
import { REGISTRATION_PAGE, REMIND_PASS_PAGE } from "../../routes";
import useFacility from "../../../utils/hooks/useFacility";
import { BsQuestionCircle } from "react-icons/bs";
import { State } from "../../store";
import { USER_TOKEN } from "../../store/auth/authMiddleware";
import { useTranslation } from "react-i18next";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { clearErrors } from "../../store/alerts/alertsActions";

const initialFormLogin: LoginData = {
  login: "",
  password: "",
  objectIds: "",
  old_token: "",
};

const Login: React.FC = () => {
  const userToken = sessionStorage.getItem(USER_TOKEN);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const facilityIds = useFacility();
  const parsedUserToken = userToken ? JSON.parse(userToken).sessionToken : "";
  const [showPassword, setShowPassword] = useState(false);

  const handleTogglePassword = () => {
    setShowPassword(!showPassword);
  };

  const alertLogin = useSelector((state: State) => state.alerts.errors);
  const loading = useSelector((state: State) => state.auth.loading);

  const [form, setForm] = useState<LoginData>({
    ...initialFormLogin,
    objectIds: facilityIds,
    old_token: parsedUserToken,
  });
  useEffect(() => {
    if (Boolean(facilityIds)) {
      setForm({ ...form, objectIds: facilityIds });
    }
  }, [facilityIds]);

  useEffect(() => {
    dispatch(clearErrors());
    //eslint-disable-next-line
  }, []);

  return (
    <div className="login-page flex-center-center">
      <div className="padding-big box shadow border">
        <h1 className="italic">{t("zaloguj_sie")}</h1>
        <span className="flex-center-center">
          {t("nie_masz_konta")}?
          <button className="button medium padding-zero button-text-main" onClick={() => navigate(REGISTRATION_PAGE)}>
            {t("utworz_konto")}
          </button>
        </span>
        <div className="forms">
          <div className="form-icon">
            <input
              className="form-label"
              type={"text"}
              id={"email"}
              name={"email"}
              placeholder={"E-mail"}
              value={form.login}
              onChange={(event) => setForm({ ...form, login: event.target.value })}
            />
          </div>

          <div className="form-icon">
            <input
              className="form-label"
              type={showPassword ? "text" : "password"}
              id={"password"}
              name={"password"}
              placeholder={t("haslo")}
              value={form.password}
              onChange={(event) => setForm({ ...form, password: event.target.value })}
            />
            <span className="password-toggle-icon" onClick={handleTogglePassword}>
              {showPassword ? <FaEyeSlash fontSize={24} /> : <FaEye fontSize={24} />}
            </span>
          </div>
        </div>
        {alertLogin && alertLogin.length > 0 && <div className="alert alert-red">{alertLogin}</div>}

        <div className="flex-between-center buttons">
          <button
            className="button big padding-big button-fill-main full-button"
            onClick={() => dispatch(logInWithPassword(form))}
          >
            {!loading ? t("zaloguj_sie") : t("logowanie")}
          </button>
        </div>

        <div>
          <button
            className="button medium padding-medium button-text-main full-button"
            onClick={() => navigate(REMIND_PASS_PAGE)}
          >
            {t("nie_pamietam_hasla")}
            <BsQuestionCircle className="icon-second" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default Login;
